import { api } from "@/api";
import { CajaApertura } from "@/shared/types/caja-apertura";
import { TransferenciaRequest } from "@/shared/types/transferencia";
import { sleep } from "@/shared/utils";

export interface OpenCajaRequest {
    transferenciaInicial: TransferenciaRequest
}

export async function openCaja(request: OpenCajaRequest):Promise<CajaApertura> {
    await sleep(1000);
    const response = await api.post("caja_actual/open", request);
    return response.data;
}